import { getRequest } from "../../api/api";

const getCurrent = async (dispatch, urls, token) => {
  const data = await getRequest(`${urls.CURRENT_URL.url}`, token);

  return data;
};

export default getCurrent;
